module.exports = __webpack_public_path__ + "56536b6d83ff2a19ec308ad17e7a8b78.png";


//////////////////
// WEBPACK FOOTER
// ./src/ui/assets/images/icons/united_kingdom_icon.png
// module id = 1223
// module chunks = 0